import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const { Form } = Common;

const DepreciationFormCustomFields = ({
  errors,
  handleValueChange,
  handleRemoveYear,
  handleAddYear,
  isSubmitted,
  t,
  values,
}) => {
  let { rates: [rate = { percentages: [], date: new Date(), lastYearMonths: 0 }] = [] } = values;

  const totalPercentage = () => {
    return rate.percentages.reduce((re, p) => parseFloat(p) + re, 0) || 0;
  };

  return (
    <Form.Section title={t('depreciations.form.percents')}>
      <div className="row align-items-center">
        <div className="col-md-3" />
        <div className="col-md-6">
          <table className="table table-striped table-hover table-condensed">
            <thead>
              <tr>
                <th className="align-middle" width="10%">
                  {t('depreciations.fields.year')}
                </th>
                <th className="align-middle" width="70%">
                  {t('depreciations.fields.percentage')}
                </th>
                <th className="text-center align-middle" width="20%">
                  {t('common.actions')}
                </th>
              </tr>
            </thead>
            <tbody>
              {rate.percentages.length === 0 && <Common.EmptyTable colSpan={3} />}
              {rate.percentages.map((percentage, index) => (
                <tr key={index}>
                  <td className="align-middle">{index + 1}</td>
                  <td className="align-middle">
                    <Form.FieldInput
                      error={
                        (isSubmitted &&
                          errors['rates[0]'] &&
                          errors['rates[0]'][`percentages[${index}]`]) ||
                        {}
                      }
                      type="number"
                      iconRight="percent"
                      inputSize="sm"
                      className="text-right"
                      name={`rates[0].percentages[${index}]`}
                      placeholder={t('depreciations.fields.percentage')}
                      handleChange={handleValueChange}
                      value={percentage}
                    />
                  </td>
                  <td className="text-center align-middle">
                    <a
                      href={'#remove-customfield'}
                      className="btn btn-sm btn-outline-danger"
                      onClick={(e) => {
                        e.preventDefault();
                        handleRemoveYear(index);
                      }}
                    >
                      {t('actions.delete')}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td>{t('depreciations.fields.total')}</td>
                <td className="text-right">{totalPercentage()} %</td>
                <td className="text-center">
                  <a
                    href={'#add-customfield'}
                    className="btn btn-sm btn-outline-success"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddYear();
                    }}
                  >
                    {t('actions.addOther')}
                  </a>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div className="row align-items-center">
        <div className="col-md-3" />
        <div className="col-md-6">
          <Form.FieldInput
            // error={
            //   (isSubmitted &&
            //     errors["rates[0]"] &&
            //     errors["rates[0]"][`percentages[${index}]`]) ||
            //   {}
            // }
            type="number"
            // iconRight="percent"
            inputSize="md"
            className="text-left"
            name="rates[0].lastYearMonths"
            label={t('depreciations.fields.monthslastyear')}
            placeholder={t('depreciations.fields.monthslastyear')}
            handleChange={handleValueChange}
            value={rate.lastYearMonths}
          />
        </div>
      </div>
    </Form.Section>
  );
};

export default translate()(DepreciationFormCustomFields);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/form/sections/DepreciationFormYears.js